import { render } from "./NewsDetailJun2025Page.vue?vue&type=template&id=f6a9f692"
import script from "./NewsDetailJun2025Page.vue?vue&type=script&lang=js"
export * from "./NewsDetailJun2025Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__